var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompassBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8026 6.4C13.66 8.3592 6 17.285 6 28c0 12.1503 9.8497 22 22 22s22-9.8497 22-22c0-10.7149-7.66-19.6407-17.8027-21.6l1.3787 3.4314C41.3485 12.2139 47 19.4469 47 28c0 10.4934-8.5066 19-19 19S9 38.4934 9 28c0-8.5531 5.6515-15.7861 13.4239-18.1686l1.3787-3.4315Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 9.6 28 4l2.25 5.6L28 12l-2.25-2.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassBorder);
export default __webpack_public_path__ + "static/media/compass_border.fccbc5f9c19764d9afc0ba6791abbde1.svg";
export { ForwardRef as ReactComponent };